// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gtVc","title":"styles_title__1vPLu"};